import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    cancel: string;
    confirm: (hasPaymentMethod: boolean) => string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Button text to cancel payment method changes */
            cancel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "BillingStripeElementContainer.cancel?c=2ojhd8rzicmo0", defaultMessage: "Cancel" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Button text for confirming payment method changes. Shows "Continue to Checkout" when a payment method exists, "Save" when adding a new one. */
            confirm: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (hasPaymentMethod: boolean): string => __intl__.intl().formatMessage({ id: "BillingStripeElementContainer.confirm?c=3gok5az2ai99z", defaultMessage: "{hasPaymentMethod, select, true {Continue to Checkout} other {Save}}" }, { hasPaymentMethod: hasPaymentMethod }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
